
export const SET_MSG = 'AUTH_MSG';
export const SET_EDITAR = 'TRABALHADOR_EDITAR';
export const SET_LISTA = 'TRABALHADOR_LISTA';